module.exports = __webpack_public_path__ + "static/media/amex.d01fdbd8.svg";